/* eslint-disable max-len */
import { Component, OnInit,Input } from '@angular/core';

@Component({
  selector: 'app-profile-pic',
  templateUrl: './profile-pic.component.html',
  styleUrls: ['./profile-pic.component.scss'],
})
export class ProfilePicComponent implements OnInit {

  @Input() isStory = false;
  profilePic =localStorage.getItem('athlete') ? JSON.parse(localStorage.getItem('athlete')).profile : '/assets/images/logo.png';

  ngOnInit() {
    //console.log(localStorage.getItem('athlete'));
    this.profilePic =localStorage.getItem('athlete') ? JSON.parse(localStorage.getItem('athlete')).profile : '/assets/images/logo.png';

  }

}
